(function() {
  if (window.__cdInsuranceBound) return;
  window.__cdInsuranceBound = true;

  var cdInsuranceConfig = window.CD_INSURANCE || {};
  var insurancePriceCents = Number(cdInsuranceConfig.insurancePriceCents || 0);
  var moneyFormat = cdInsuranceConfig.moneyFormat || '${{amount}}';

  const interval = setInterval(() => {
    const toggle = document.querySelector('.cd-insurance__toggle');

    if (toggle) {
      let isInsuranceAdded = cdInsuranceConfig.productInCart === true || cdInsuranceConfig.productInCart === 'true';

      if (!isInsuranceAdded) {
        toggle.click();
      }

      clearInterval(interval);
    }
  }, 1500);

  function getDisplayedSubtotal() {
    let el = document.querySelectorAll('.cart-drawer__totals__row__money');
    el = el[1] ? el[1] : el[0];
    if (!el) return null;
    return el;
  }

  function parseCentsFromText(text) {
    var raw = text.replace(/[^0-9.,]/g, '').trim();

    var lastComma = raw.lastIndexOf(',');
    var lastPeriod = raw.lastIndexOf('.');

    if (lastComma > lastPeriod) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else if (lastPeriod > lastComma) {
      raw = raw.replace(/,/g, '');
    }

    return Math.round(parseFloat(raw) * 100);
  }

  function updateSubtotalDOM(addOrRemove) {
    var el = getDisplayedSubtotal();
    if (!el) return;

    var currentCents = parseCentsFromText(el.textContent);
    var newCents = addOrRemove === 'add'
      ? currentCents + insurancePriceCents
      : currentCents - insurancePriceCents;

    el.textContent = formatMoney(newCents);
  }

  function syncA11y(checkbox) {
    checkbox.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartDrawerSubtotal(cart) {
    var totalsWrap = document.querySelector('.cart-drawer__totals');
    if (!totalsWrap) return;

    var moneyNodes = totalsWrap.querySelectorAll('.cart-drawer__totals__row__money');
    if (!moneyNodes.length) return;

    var subtotalNode = moneyNodes[moneyNodes.length - 1];
    subtotalNode.textContent = formatMoney(cart.items_subtotal_price);
  }

  async function getCart() {
    var response = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) throw new Error('Failed to load cart.');
    return await response.json();
  }

  async function addInsurance(container) {
    var variantId = Number(container.dataset.variantId);
    var quantity = Number(container.dataset.quantity) || 1;

    if (!variantId || Number.isNaN(variantId)) {
      throw new Error('Missing valid variant ID.');
    }

    var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function() { return {}; });
      throw new Error(errorData.description || 'Failed to add insurance.');
    }

    // return await response.json();
  }

  async function removeInsurance(container) {
    var variantId = Number(container.dataset.variantId);

    if (!variantId || Number.isNaN(variantId)) {
      throw new Error('Missing valid variant ID.');
    }

    // var cart = await getCart();
    // var lineItem = cart.items.find(function(item) {
    //   return Number(item.variant_id) === variantId;
    // });
    // if (!lineItem) return cart;

    console.log('Variant id is ', variantId);

    var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: `${variantId}`,
        quantity: 0
      })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function() { return {}; });
      throw new Error(errorData.description || 'Failed to remove insurance.');
    }

    console.log('item is removed');
    return await response.json();
  }

  document.addEventListener('change', async function(event) {
    var checkbox = event.target.closest('.cd-insurance [data-insurance-toggle]');
    if (!checkbox) return;

    var container = checkbox.closest('.cd-insurance');
    if (!container) return;
    if (container.dataset.loading === 'true') return;

    container.dataset.loading = 'true';
    container.classList.add('is-loading');
    syncA11y(checkbox);

    try {
      if (checkbox.checked) {
        updateSubtotalDOM('add');
        await addInsurance(container);
      } else {
        updateSubtotalDOM('remove');
        await removeInsurance(container);
      }

      syncA11y(checkbox);
    } catch (error) {
      checkbox.checked = !checkbox.checked;
      updateSubtotalDOM(checkbox.checked ? 'add' : 'remove');
      syncA11y(checkbox);
      console.error(error);
    } finally {
      container.dataset.loading = 'false';
      container.classList.remove('is-loading');
    }
  });

  document.querySelectorAll('.cd-insurance [data-insurance-toggle]').forEach(function(checkbox) {
    syncA11y(checkbox);
  });
})();

(function() {
  if (window.__cdInsuranceInfoBound) return;
  window.__cdInsuranceInfoBound = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.cd-insurance [data-insurance-info-toggle]');
    if (!button) return;

    var container = button.closest('.cd-insurance');
    if (!container) return;

    var panelId = button.getAttribute('aria-controls');
    var panel = panelId ? container.querySelector('#' + CSS.escape(panelId)) : container.querySelector('[data-insurance-info-panel]');
    if (!panel) return;

    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

    if (isExpanded) {
      panel.setAttribute('hidden', 'hidden');
    } else {
      panel.removeAttribute('hidden');
    }
  });
})();